import base from "@/admin/locale/zh_CN/base";
import route from "@/admin/locale/zh_CN/route";
import menu from "@/admin/locale/zh_CN/menu";

export default {
  route,
  menu,
  ...base,
};
